export default __webpack_public_path__ + "static/media/full.210c1c27.svg";